import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const UserDetailConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.UserImageContainer>
        <Skeleton variant="circular" width={144} height={144} />
        <Styles.UploadInfo>
          <Skeleton variant="text" width={160} height={24} />
          <Skeleton variant="text" width="60%" height={20} />
          <Skeleton variant="rounded" width={180} height={40} />
        </Styles.UploadInfo>
      </Styles.UserImageContainer>

      <Styles.UserInfoContainer>
        <Styles.InputsRow>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.InputsRow>
        <Styles.InputsRow>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.InputsRow>
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.UserInfoContainer>
    </Styles.Container>
  )
}

export default UserDetailConfigurationSkeleton
